/**
 * デモモード制限機能の型定義
 * FL-154: デモ体験時の外部サービス無効化
 */

/**
 * デモモードで制限対象となる機能
 */
export enum DemoFeature {
  // 外部通信系
  EMAIL_SEND = 'email_send',
  AI_API = 'ai_api',
  LINE_NOTIFICATION = 'line_notification',
  GOOGLE_MAPS = 'google_maps',

  // アカウント管理系
  USER_REGISTRATION = 'user_registration',
  PASSWORD_RESET = 'password_reset',

  // 将来拡張用
  SMS_SEND = 'sms_send',
  EXTERNAL_DATA_SYNC = 'external_data_sync',
}

/**
 * 制限チェック結果
 */
export interface RestrictionResult {
  /** 制限されているかどうか */
  isRestricted: boolean;
  /** 制限理由メッセージ */
  message: string;
  /** 推奨アクション */
  recommendedAction?: string;
}

/**
 * サービス種別（モックレスポンス用）
 */
export enum ServiceType {
  EMAIL = 'email',
  AI_API = 'ai_api',
  LINE = 'line',
  GOOGLE_MAPS = 'google_maps',
  SMS = 'sms',
}

/**
 * デモモード設定
 */
export interface DemoModeConfig {
  /** デモモードが有効かどうか */
  enabled: boolean;
  /** 制限対象機能のリスト */
  restrictedFeatures: DemoFeature[];
  /** カスタムメッセージ設定 */
  customMessages?: Record<DemoFeature, string>;
}

/**
 * モックレスポンス基本形
 */
export interface MockResponse {
  /** 成功フラグ */
  success: boolean;
  /** メッセージ */
  message: string;
  /** データ */
  data?: any;
  /** デモモード識別子 */
  isDemoMock: true;
}

/**
 * メール送信モックレスポンス
 */
export interface EmailMockResponse extends MockResponse {
  messageId: string;
  to: string[];
  subject: string;
}

/**
 * AI APIモックレスポンス
 */
export interface AIApiMockResponse extends MockResponse {
  response: string;
  model: string;
  usage?: {
    promptTokens: number;
    completionTokens: number;
    totalTokens: number;
  };
}

/**
 * LINE通知モックレスポンス
 */
export interface LineNotificationMockResponse extends MockResponse {
  userId: string;
  messageType: string;
  content: string;
}
